import React from 'react';
// import logo from './logo.svg';
import './App.css';
import { IBizNavigationSetMenuResult } from 'dingtalk-jsapi/api/biz/navigation/setMenu';
import { getJsSDK } from './jssdk';


function App() {
  

  const testSetRight = () => {
    const jssdk = getJsSDK();
    
    const ddConfig = jssdk?.getDDConfig();
    if(jssdk && ddConfig){
      jssdk.setRight(
        true,//控制按钮显示， true 显示， false 隐藏， 默认true
        true,//是否控制点击事件，true 控制，false 不控制， 默认false
        '测试',//控制显示文本，空字符串表示显示默认文本
        function() {
          alert('点击了测试');
        },
      );
    }else{
      alert('jssdk not ready');
    }
  }

  /**
  * https://open.dingtalk.com/document/orgapp/set-the-right-side-of-the-navigation-bar-to-multiple 
  */
  const testSetRightMenu = () => {
    const jssdk = getJsSDK();
    const ddConfig = jssdk?.getDDConfig();
    if(jssdk && ddConfig){
      window.dd.biz.navigation.setMenu({
        backgroundColor: "#FFFFFF",
        textColor: "##1E1E20",
        items: [
          {
            id: '1',
            text: '全标已读',
            iconId: 'ok',
            showRedDot: false,
            badge: '2',
            //url: 'https://app.qmailbox.cn/icon/check.png',
          },
          {
            id: '2',
            iconId: 'setting',
            text: '消息免打扰',
            showRedDot: false,
            badge: '3',
            // url: 'https://app.qmailbox.cn/icon/alerts.png',
          },
          {
            id: '3',
            iconId: 'more',
            text: '更多',
            showRedDot: false,
            badge: '3',
            // url: 'https://app.qmailbox.cn/icon/alerts.png',
          },
        ],
        onSuccess : function(data: IBizNavigationSetMenuResult) {
          alert('点击了测试'+data.id);
        },
      });
    }else{
      alert('dd or ddConfig not ready');
    }
  }


  const wwSetRight = ()=>{
    const jssdk = getJsSDK();
    jssdk?.ww?.hideOptionMenu();
  }


  return (
    <div className="App">
      <header className="App-header">
        <button className='Test-Button' onClick={()=>{
          const jssdk = getJsSDK();
          const ddConfig = jssdk?.getDDConfig();
          if(jssdk && ddConfig){
              window.dd.biz.contact.choose({
                multiple: true, //是否多选：true多选 false单选； 默认true
                //users: ['10001', '10002', ...], //默认选中的用户列表，员工userid；成功回调中应包含该信息
                corpId: ddConfig.corpId, //企业id
                max: 10, //人数限制，当multiple为true才生效，可选范围1-1500
                onSuccess: function(data:any) {
                  console.log(data);
                /* data结构
                  [{
                    "name": "张三", //姓名
                    "avatar": "
            http://g.alicdn.com/avatar/zhangsan.png
            " //头像图片url，可能为空
                    "emplId": '0573', //员工userid
                   },
                   ...
                  ]
                */
                },
                onFail : function(err:any) {
                  console.error(err);
                  alert('onFail: ' + JSON.stringify(err));
                }
             });
            }else{
              alert('dd or ddConfig not ready');
            }
          }
        }>
          选择用户
        </button>


        <button className='Test-Button'  onClick={()=>{
          alert('setNavigationTitle');
          const jssdk = getJsSDK();
          const ddConfig = jssdk?.getDDConfig();
          if(jssdk && ddConfig){
            window.dd.biz.navigation.setTitle({
                title : '文档测试标题',//控制标题文本，空字符串表示显示默认文本
              });
            }else{
              alert('dd or ddConfig not ready');
            }
          }
        }>
          设置标题
        </button>

        <button className='Test-Button'  onClick={()=>{
          const jssdk = getJsSDK();
          if(jssdk){
            jssdk.scan(['barCode'], // type 为 all、qrCode、barCode，默认是all。
              (data:any) => {
                alert(`scan result:${JSON.stringify(data)}`);
              },
              (err:any) => {
                alert('打开扫一扫失败'+JSON.stringify(err));
              }
            );
            }else{
              alert('jssdk not ready');
            }
          }
        }>
          扫一扫
        </button>

        <button className='Test-Button'  onClick={testSetRight}>
          设置右侧按钮
        </button>

        <button className='Test-Button'  onClick={testSetRightMenu}>
          设置右侧目录
        </button>

        <button className='Test-Button'  onClick={wwSetRight}>
          企微隐藏右侧按钮
        </button>
        <a className='Test-Button' href='https://www.h3yun.com/index.html?corpid=dingaaef4b1e8dd1290e&dingappid=3411&type=ISV&appid=home&solutioncode=home&suitekey=suitefcoyqxthbd1xwjiu'>跳转氚云</a>
      </header>
    </div>
  );
}

export default App;
